'use client';

import { createContext, useContext } from 'react';

export const HideDateStampContext = createContext(false);

export const useHideDateStamp = () => useContext(HideDateStampContext);
